import { array, object, string } from '@calendly/form/validation'

import { DAY_KEYS } from './constants'

export const validationSchema = () => object().shape({
  days: object().shape(
    DAY_KEYS.reduce((acc, key) => ({ ...acc,
      [key]: array().of(object().shape({
        from: string(),
        to: string(),
        error: string().nullable(),
      }).test(
        'hasError',
        'Interval has error',
        ({ error }) => !error
      )
      ) }), {}),
  ),
  timezone: string()
})
